// src/pages/MyGroups/PlannerModal.tsx
import React from "react";
import { Button } from "react-bootstrap";

interface PlannerModalProps {
  plans: { title: string; id: string }[];
  onClose: () => void;
}

const PlannerModal: React.FC<PlannerModalProps> = ({ plans, onClose }) => {
  return (
    <div className="planner-modal-backdrop" onClick={onClose}>
      <div className="planner-modal" onClick={(e) => e.stopPropagation()}>
        <h5>Select a Planner plan</h5>
        {plans.map((p) => (
          <a
            key={p.id}
            href={`https://planner.cloud.microsoft/webui/plan/${p.id}`}
            target="_blank"
            rel="noreferrer"
          >
            {p.title}
          </a>
        ))}
        <Button variant="secondary" className="mt-2" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default PlannerModal;